import React from 'react'
import { CardGroup, CardWithHeader } from 'ui'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import StepPointOptions from 'pages/app/cleaning/partials/StepPointOptions'
import { Fieldset } from 'layouts'
import StepFields from 'pages/app/cleaning/partials/StepFields'

export default function StepCategorySection ({ isCompleted }) {
  return (
    <CardGroup>
      <ValueToCollection name='steps'>
        <ForEachModel>
          <CardWithHeader header={<Displays.Text name='description' />}>
            <div className='mb-6'>
              <StepPointOptions isCompleted={isCompleted} />
            </div>
            <Fieldset cols={2}>
              <StepFields isCompleted={isCompleted} />
            </Fieldset>
          </CardWithHeader>
        </ForEachModel>
      </ValueToCollection>
    </CardGroup>
  )
}
